import { AnyAction } from 'redux';

import { AssessmentSummaryPayload } from 'types/assessment-payload';
import { Error } from 'types/error';
import {
  FETCH_ASSESSMENT_SUMMARY_ERROR,
  FETCH_ASSESSMENT_SUMMARY_START,
  FETCH_ASSESSMENT_SUMMARY_SUCCESS,
  SET_DOCUMENT_METADATA_SELECTED,
} from 'actions/assessmentSummary/types';
import {
  IFetchAssessmentSummaryError,
  IFetchAssessmentSummarySuccess,
} from 'actions/assessmentSummary';
import { ReviewResult } from 'types/check';

export type AssessmentSummaryReducerType = {
  isLoading: boolean;
  summary: AssessmentSummaryPayload | null;
  error: Error | null;
  documentMetadataChecksSelected?: boolean;
  documentMetadataChecksSelected_type?: ReviewResult;
};

export const initialState = (): AssessmentSummaryReducerType => ({
  isLoading: false,
  summary: null,
  error: null,
});

function handleFetchStart(state: AssessmentSummaryReducerType) {
  return {
    ...state,
    ...initialState(),
    isLoading: true,
  };
}

function handleFetchSuccess(
  state: AssessmentSummaryReducerType,
  action: IFetchAssessmentSummarySuccess
) {
  return {
    ...state,
    isLoading: false,
    summary: action.summary,
  };
}

function handleFetchError(
  state: AssessmentSummaryReducerType,
  action: IFetchAssessmentSummaryError
) {
  return {
    ...state,
    isLoading: false,
    error: { ...action.error },
  };
}

export default function AssessmentSummaryReducer(
  state = initialState(),
  action: AnyAction
) {
  switch (action.type) {
    case FETCH_ASSESSMENT_SUMMARY_START:
      return handleFetchStart(state);
    case FETCH_ASSESSMENT_SUMMARY_SUCCESS:
      return handleFetchSuccess(
        state,
        action as IFetchAssessmentSummarySuccess
      );
    case FETCH_ASSESSMENT_SUMMARY_ERROR:
      return handleFetchError(state, action as IFetchAssessmentSummaryError);
    case SET_DOCUMENT_METADATA_SELECTED:
      return {
        ...state,
        documentMetadataChecksSelected: action.action.state,
        documentMetadataChecksSelected_type: action.action.type,
      };
    default:
      return state;
  }
}
